[
  {
    "code": "SR-BR",
    "name": "Brokopondo"
  },
  {
    "code": "SR-CM",
    "name": "Commewijne"
  },
  {
    "code": "SR-CR",
    "name": "Coronie"
  },
  {
    "code": "SR-MA",
    "name": "Marowijne"
  },
  {
    "code": "SR-NI",
    "name": "Nickerie"
  },
  {
    "code": "SR-PR",
    "name": "Para"
  },
  {
    "code": "SR-PM",
    "name": "Paramaribo"
  },
  {
    "code": "SR-SA",
    "name": "Saramacca"
  },
  {
    "code": "SR-SI",
    "name": "Sipaliwini"
  },
  {
    "code": "SR-WA",
    "name": "Wanica"
  }
]